import type { DeskSession } from "../hooks/useDeskSession";
import { nextOpId } from "../lib/edit-helpers";
import { coachLineFor } from "./tools.js";
import { ToolCartButton } from "./ToolCartButton.js";

function durationSeconds(ticks: number, tickRate: number): string {
  return `${(ticks / tickRate).toFixed(1)}s`;
}

export function CutTool({
  session,
}: {
  session: DeskSession;
}) {
  const { pack, resolved, applyOp } = session;
  const order = resolved.beatOrder;

  const toggleBeat = (beatId: string, omitted: boolean) => {
    applyOp({
      kind: "cut",
      opId: nextOpId(omitted ? "cut-keep" : "cut-omit"),
      beatId,
      mode: omitted ? "keep" : "omit",
    });
  };

  return (
    <div className="tool-panel kid-tool" data-testid="cut-tool">
      <ToolCartButton tool="cut" />
      <h3>Clips</h3>
      <p className="coach-line" data-testid="coach-line">
        {coachLineFor("cut")}
      </p>
      <ul className="beat-card-list">
        {order.map((beatId) => {
          const beat = pack.beats.find((b) => b.id === beatId)!;
          const cut = resolved.cuts.get(beatId);
          const omitted = cut?.mode === "omit";
          const trimmed = cut?.mode === "trim";
          const inTick = trimmed && cut.inTick !== undefined ? cut.inTick : beat.startTick;
          const outTick = trimmed && cut.outTick !== undefined ? cut.outTick : beat.endTick;
          const span = Math.max(0, outTick - inTick);

          return (
            <li key={beatId} className={omitted ? "omitted" : "kept"} data-beat-id={beatId}>
              <button
                type="button"
                className={`beat-card${omitted ? " hidden-beat" : " included-beat"}`}
                data-testid={`beat-card-${beatId}`}
                aria-pressed={!omitted}
                aria-label={`${beat.label}, ${omitted ? "hidden" : "included"}, ${durationSeconds(span, pack.tickRate)}. Tap to ${omitted ? "include" : "hide"}.`}
                onClick={() => toggleBeat(beatId, omitted)}
              >
                <span className="beat-card-check" aria-hidden>
                  {omitted ? "○" : "✓"}
                </span>
                <span className="beat-card-body">
                  <strong>{beat.label}</strong>
                  <span className="beat-card-dur">{durationSeconds(span, pack.tickRate)}</span>
                </span>
                <span className="beat-card-state">{omitted ? "Hidden" : "In reel"}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
